// ⚠️  GENERATED — do not edit. Run `npm run inferrex:generate` to regenerate.
/**
 * @inferrex/sdk — Oauth resource client
 * Generated from route definitions in services/api/route-definitions.ts
 */

import type { HttpClient, RequestOptions } from '../http.js';

export class OauthClient {
  constructor(private readonly http: HttpClient) {}

  /** Begin an OAuth 2.0 authorization-code flow for a connector. Builds the provider authorize URL from its ProviderManifest oauth2 config (authorize endpoint, client_id from env, requested scopes, a PKCE S256 challenge when the provider declares pkce) and mints a single-use CSRF `state` token (persisted in Redis for 10 minutes, bound to the customer, connection, environment and redirectUri, consumed by GET /oauth/callback/:providerKey). Returns { authorizeUrl, state } — the UI redirects the user to authorizeUrl. */
  async oAuthInitiate(request: { providerKey: string; connectionId: string; redirectUri: string; scopes?: string[]; environmentId?: string }, requestOptions?: RequestOptions): Promise<{ authorizeUrl: string; state: string }> {
    return this.http.post<{ authorizeUrl: string; state: string }>('/v1/oauth/initiate', request, requestOptions);
  }
}
